let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dT8KP")).then(() => parcelRequire('a2sgn'));